<div class="main-div">
    <div fxLayout="column" style="overflow-x: hidden;" class="center-div">

        <div [ngStyle]="{'background-image': 'url(' + bannerImage + ')'}" fxLayout="row" class="banner-div">
            <div fxLayout="row" fxLayoutAlign="center center" class="button-container">
                <button class="play-btn play-btn1" style="width: 170px;" (click)="toBottom()">PLAY NOW</button>
                <button class="play-btn play-btn1" style="width: 170px;" (click)="toPlay()">HOW TO PLAY</button>
            </div>
        </div>
        <br>
        <div  id="meetCreatics" class="meet-creatics">
            <div class="heading-div" fxLayout="row" fxFlex="100%" fxLayoutGap="25px" fxLayout.lt-md="column">
                <div class="heading">
                    MEET THESE CREATICS
                </div>
                <div class="search" fxFlex="20" fxLayout="row" fxLayoutAlign="center center">
                    <input type="text" placeholder="Search" [(ngModel)]="searchQuery"
                           (input)="search()" id="text" (ngModelChange)="onSearchQueryChange($event)">
                        <div class="ulDiv" (change)="search()" *ngIf="data == true">
                            <ul fxLayout="column" fxLayoutGap="10px">
                                <li *ngFor="let user of searchResults">
                                    <div class="li-div" fxLayout="row" fxLayoutGap="5px">
                                        <a href="userProfiles/{{user.id}}?home=false">
                                            <img *ngIf="user.imageURL !== null" src="{{user.imageURL}}">
                                            <img *ngIf="user.imageURL === null" src="assets/images/user-icon.png"
                                                alt="">
                                            <span class="user-details">{{user.value}} <span>•</span>
                                                {{user.title}}</span>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    <i *ngIf="searchItem" class="fa fa-search"></i>
                    <i (click)="clear()" *ngIf="close" class="fa fa-times"></i>
                </div>
            </div>
        </div>

        <br>
        <br>

        <div id="meetCreatics" class="carousel-container">
            <owl-carousel-o [options]="carouselOptions" class="carousel">
                <ng-container *ngFor="let item of carouselContents">
                    <ng-template carouselSlide>
                        <div (click)="redirectToProfile(item.id)" style="cursor: pointer;">
                            <div (click)="redirectToProfile(item.id)" class="treasury-item" style="cursor: pointer;" [ngStyle]="{'background-image': 'url(' + item.imageURL + ')'}">
                            </div>
                            <br>
                            <span (click)="redirectToProfile(item.id)">{{item.firstName}} {{item.lastName}}</span>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>

        <br>

        <div id="content" class="treasures-container" *ngIf="treasuryContents.length > 0">
            <br>
            <p class="treasury-heading">DISCOVER TRENDING TREASURES</p>
            <owl-carousel-o [options]="treasuryOptions" class="carousel">
                <ng-container *ngFor="let item of treasuryContents">
                    <ng-template carouselSlide>
                        <div (click)="redirectToProfile(item.id)" style="cursor: pointer;">
                            <div (click)="redirectToProfile(item.id)" class="treasury-item" style="cursor: pointer;" [ngStyle]="{'background-image': 'url(' + item.imageURL + ')'}">
                            </div>
                            <br>
                            <span (click)="redirectToProfile(item.id)">{{item.firstName}} {{item.lastName}}</span>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>        

        <div id="play" fxLayout="row" class="main-container">
            <div fxLayout="row" class="how-to-play-container">
                <div fxFlex="100%" class="flex-column">
                    <p class="title" [innerHTML]=heading></p>
                    <div>
                        <p>
                            <span class="desc" [innerHTML]=description></span>
                        </p>
                    </div>
                </div> 
            </div>
        </div>

        <br>
        <div id="play" fxLayout="row" style="justify-content: center; text-align: center;">
            <button class="play-btn" (click)="toMeetCreatics()">PLAY NOW <br> MEET CREATICS</button>
        </div>
        
    </div>
</div>
